import React, { useEffect } from 'react';
import styled from 'styled-components';

const LoadingWrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  display: grid;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  align-content: center;
  align-items: center;
  z-index: 9999999999;
  background-color: rgba(255, 255, 255, 0.97);
  svg {
    margin: auto;
    display: block;
    width: 15rem;
    height: 15rem;
  }

  .progress2 {
    margin: 4rem auto 2rem auto;
    width: 40vw;
    background: rgba(70, 50, 50, 0.1);
  }

  .progress-bar2 {
    height: 4px;
    background-color: #d4ae6a;
    transition: 0.4s linear;
    transition-property: width, background-color;
  }

  .progress-moved .progress-bar2 {
    width: 100%;
    background-color: #d4ae6a;
    animation: progressAnimation ${(props) => props.seconds}s infinite;
  }

  .message-container {
    font-size: 2.2rem;
    font-weight: bold;
    text-align: center;
  }

  @keyframes progressAnimation {
    0% {
      width: 0%;
      background-color: #d4ae6a;
    }
    100% {
      width: 100%;
      background-color: #d4ae6a;
    }
  }

  @media screen and (max-width: 768px) {
    svg {
      height: 12rem;
      width: 12rem;
    }
    .progress2 {
      width: 80vw;
    }
    .message-container {
      font-size: 1.8rem;
    }
  }
`;

const Loading = ({ seconds = 30, open, msg = 'Please Wait...' }) => {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflowY = 'auto';
      document.body.style.overflowX = 'hidden';
    };
  }, [open]);
  return (
    open && (
      <LoadingWrapper {...{ seconds }}>
        <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
          <rect fill="#bd2b2b" x="15" y="15" width="30" height="30" rx="3" ry="3">
            <animate
              attributeName="x"
              dur="2s"
              repeatCount="indefinite"
              keyTimes="0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1"
              values="15;55;55;55;55;15;15;15;15"
              begin="-1.8333333333333333s"
            ></animate>
            <animate
              attributeName="y"
              dur="2s"
              repeatCount="indefinite"
              keyTimes="0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1"
              values="15;55;55;55;55;15;15;15;15"
              begin="-1.3333333333333333s"
            ></animate>
          </rect>
          <rect fill="#d3ae69" x="15" y="15" width="30" height="30" rx="3" ry="3">
            <animate
              attributeName="x"
              dur="2s"
              repeatCount="indefinite"
              keyTimes="0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1"
              values="15;55;55;55;55;15;15;15;15"
              begin="-1.1666666666666667s"
            ></animate>
            <animate
              attributeName="y"
              dur="2s"
              repeatCount="indefinite"
              keyTimes="0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1"
              values="15;55;55;55;55;15;15;15;15"
              begin="-0.6666666666666666s"
            ></animate>
          </rect>
          <rect fill="#96a16f" x="15" y="15" width="30" height="30" rx="3" ry="3">
            <animate
              attributeName="x"
              dur="2s"
              repeatCount="indefinite"
              keyTimes="0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1"
              values="15;55;55;55;55;15;15;15;15"
              begin="-0.5s"
            ></animate>
            <animate
              attributeName="y"
              dur="2s"
              repeatCount="indefinite"
              keyTimes="0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1"
              values="15;55;55;55;55;15;15;15;15"
              begin="0s"
            ></animate>
          </rect>
        </svg>
        <div className="progress2 progress-moved">
          <div className="progress-bar2"></div>
        </div>
        <div className="message-container">{msg}</div>
      </LoadingWrapper>
    )
  );
};

export default Loading;
